import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';

export class BcfRouterServerSession {
  public hostname!: string;
  public activeUrlFull!: string;
  public activeUrl!: string;
  public ssrSearchString!: string;
  public ssrBaseHref: string = '/'; // like /casino/ /sports/

  public updateActiveUrl(url: string): void {
    this.activeUrl = url;
  }

  public updateSSRSearchString(search: string): void {
    this.ssrSearchString = search;
  }

  public updateSsrBaseHref(baseHref: string): void {
    if (baseHref.includes('http')) {
      throw new Error('Base href should be pathname only');
    }
    this.ssrBaseHref = baseHref;
  }

  public updateHostname(hostname: string): void {
    this.hostname = hostname;
  }

  public updateActiveUrlFull(activeUrlFull: string): void {
    this.activeUrlFull = activeUrlFull;
  }
}
export function provideBcfRouterServerSession(): BcfRouterServerSession {
  return provideSingleton(BcfRouterServerSession, () => new BcfRouterServerSession());
}
